// removed by extract-text-webpack-plugin
module.exports = {"cookie-bar":"index__cookie-bar___2sPLb","cookieBar":"index__cookie-bar___2sPLb","active":"index__active___1DE-7","moveIn":"index__moveIn___2VH5S","container":"index__container___2jZw7","confirm-text":"index__confirm-text___2X6Vi","confirmText":"index__confirm-text___2X6Vi","button":"index__button___18pM5","button-content":"index__button-content___2otOo","buttonContent":"index__button-content___2otOo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/molecules/CookieBar/index.css
// module id = 749
// module chunks = 12